/**
 * Copyright 2026 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { Typography } from "@mui/material";

const NotesRow = ({ colCount, note }) => (
    <TableRow>
      <TableCell sx={{ fontWeight: 800 }} colSpan={colCount}>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {note}
        </Typography>
      </TableCell>
    </TableRow>
  );

export default NotesRow;
